export enum RegistrationSource {
  Idp = 'idp',
  Local = 'regular',
}